import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { XSmallIcon } from 'components/icons/XSmall'
import { useTranslationTyped } from 'i18n/i18n'

export const ExpiredView = observer(function ExpiredView() {
  const { tt } = useTranslationTyped()
  return (
    <div className={classNames(`mt-1 grow-0 py-5 text-center`)}>
      <div className="text-body-medium text-grey-text">
        {tt.dart.experience()}
      </div>
      <h2 className="mt-3 text-title-large">
        <XSmallIcon
          size={20}
          className="mr-1 inline-block align-top text-breakout-dark-green"
        />
        {tt.student_assignment.assignment_expired()}
      </h2>
    </div>
  )
})
